import {useSelector} from 'react-redux';
import i18n from 'i18next';
import {DEFAULT_PLAYER_LABELS} from '../incase-domain/playerLabel';
import {selectedPresentationSelector} from '../store/selectors/presentation.selectors';

export function usePresentationLabels(): (code: string) => string | undefined {
    const selectedPresentation = useSelector(selectedPresentationSelector);

    return (code: string): string | undefined => {
        const label = selectedPresentation.languageConfig?.labels?.find((item) => item.code === code);

        if (label) {
            const value = (label as never)[`${i18n.language}`];
            if (value) {
                return value;
            }
        }

        const defaultLabel = DEFAULT_PLAYER_LABELS.find((item) => item.code === code);
        return defaultLabel?.en;
    };
}
